import type {IconType} from "react-icons";
import {
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaExclamationCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaQuestionCircle,
  FaTimesCircle,
} from "react-icons/fa";

const Icons: Record<string, IconType | null> = {
  request: FaArrowAltCircleRight,
  response: FaArrowAltCircleLeft,
  error: FaTimesCircle,
  warning: FaExclamationTriangle,
  debug: FaExclamationCircle,
  info: FaInfoCircle,
  dialog: FaQuestionCircle,
  verbose: FaInfoCircle,
  log: FaInfoCircle,
  /*
  possible values found in live data: "txn", "warn", "startGroup", "endGroup"
  the list is not complete
   */
};

interface ConsoleOutputIconProps {
  className?: string;
  type: string;
}

export const BrowserConsoleMessageIcon = ({className, type}: ConsoleOutputIconProps) => {
  const IconComponent = Icons[type];
  if (!IconComponent) {
    return null;
  }
  return <IconComponent className={className} />;
};
